module.exports = __webpack_public_path__ + "img/8abaf77e4db4fecca47a0e63482b805e.f9fb76ad.png";